import { dedupeLocations } from 'Common/functions/Location';
import { LocationType } from 'Generated/graphql';
import { useMemo } from 'react';

type locations = {
  id: string;
  streetAddress: string;
  placeId: string;
  type: LocationType;
}[]

type CustomerLocationSelectSmallProps<T extends locations = locations> = {
  locations: Record<string, T>;
  value: string;
  onSelect: (id: string) => void;
}

const CustomerLocationSelectSmall: React.FC<CustomerLocationSelectSmallProps> = ({
  locations,
  value,
  onSelect,
}) => {
  const entries = Object.entries(locations);
  const selectedLocation = useMemo(() => {
    for (let i = 0; i < entries.length; i++) {
      for (let j = 0; j < entries[i][1].length; j++) {
        const loc = entries[i][1][j];
        if (loc.id === value) {
          return loc;
        }
      }
    }
  }, [value]);
  const isRetail = selectedLocation?.type === LocationType.ServiceProviderRetail;

  return (
    <>
      <select
        className="w-full select pl-0"
        value={value}
        onChange={e => {
          const id = e.target.value;
          onSelect(id);
        }}
      >
        {entries.map(
          ([label, locs], i) => locs.length > 0 ? (
            <optgroup key={i} label={label}>
              {dedupeLocations(locs).map(l => (
                <option key={l.id} value={l.id}>
                  {l.streetAddress}
                </option>
              ))}
            </optgroup>
          ) : null)}
      </select>
      <small className="small mt-1 mb-2 inline">
        {isRetail ? (
          <>
            You&apos;ll Travel And Meet The Service Provider Here.
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${selectedLocation.streetAddress}`}
              className="small inline underline ml-1"
              target="_blank"
              referrerPolicy="no-referrer"
            >
              Get Directions
            </a>
          </>
        ) : 'The Service Provider Will Travel And Meet You Here.'}
      </small>
    </>
  );
};

export default CustomerLocationSelectSmall;
